<template>
  <div class="tab-main">
    <div class="tip">
      各级、各类政府机构、事业单位；如：民政、公安机关、司法、市政、工商、交通、旅游、医院、教育、学校等机构
    </div>
    <el-form label-position="right"
             class="fast-login top-40"
             :model="dataForm"
             :rules="dataRule"
             label-width="150px"
             ref="dataForm"
             status-icon>
      <el-form-item label="政府/单位名称："
                    prop="companyName">
        <el-input v-model="dataForm.companyName"
                  placeholder="请输入企业名称"
                  :maxlength="50"
                  clearable></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码："
                    prop="socialCreditCode">
        <el-input v-model="dataForm.socialCreditCode"
                  placeholder="请输入统一社会信用代码"
                  :maxlength="18"
                  oninput="value=value.replace(/[^A-Za-z0-9]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="办公地址："
                    prop="provinceId">
        <el-select v-model="dataForm.provinceId"
                   style="width: 30%;float:left"
                   @change="changeProvince"
                   placeholder="省">
          <el-option v-for="item in provinceList"
                     :key="item.codeP"
                     :label="item.name"
                     :value="item.codeP">
          </el-option>
        </el-select>
        <el-select v-model="dataForm.cityId"
                   style="width: 30%;float:left;margin-left:5%"
                   @change="changeCity"
                   placeholder="市">
          <el-option v-for="item in cityList"
                     :key="item.codeC"
                     :label="item.name"
                     :value="item.codeC">
          </el-option>
        </el-select>
        <el-select v-model="dataForm.areaId"
                   style="width: 30%;float:left;margin-left:5%"
                   placeholder="区">
          <el-option v-for="item in areaList"
                     :key="item.codeA"
                     :label="item.name"
                     :value="item.codeA">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="dataForm.address"
                  placeholder="详细地址：如街道，道路，园区，门牌号等"></el-input>
      </el-form-item>
      <el-form-item class="multi-line"
                    label="事业单位法人证书/统一社会信用代码证书图片">
        <div class="upLoad-but"
             v-show="businessLicenseUrl">
          <img :src="businessLicenseUrl"
               width="150px"
               height="100px" />
          <i class="el-icon-delete delete" @click="deleteHandle(businessLicenseId, 'businessLicense')"></i>
        </div>
        <el-upload class="upload-demo"
                   :action="actionUrl"
                   :data="{ fileSuffixType: 'picture2' }"
                   :accept="'.jpg,.bmp,.gif,.jpeg,.png,.pdf'"
                   :show-file-list="false"
                   :with-credentials="true"
                   :headers="upLoadHeaders"
                   :on-success="handleSuccess"
                   :before-upload="beforeUpload">
          <el-button class="upLoad-but"
                     size="small"
                     v-show="!businessLicenseId"
                     icon="el-icon-plus"></el-button>
        </el-upload>
      </el-form-item>
    </el-form>
  </div>
</template>
<script >
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      actionUrl: window.SITE_CONFIG['apiURL'] + '/help/fileupload/sys/v2/upload',
      upLoadHeaders: {
        'Authorization': 'Bearer ' + getAccessToken()
      },
      businessLicenseId: '',
      businessLicenseUrl: '',
      dataForm: {
        companyName: '',
        nature: '20',
        industry: [],
        socialCreditCode: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        address: '',
        fileList: []
      },
      // 省市区
      provinceList: [],
      cityList: [],
      areaList: []
    }
  },
  computed: {
    dataRule () {
      var validateProvinceId = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请选择省'))
        } else if (!this.dataForm.cityId) {
          return callback(new Error('请选择市'))
        } else if (!this.dataForm.areaId) {
          return callback(new Error('请选择区'))
        } else {
          callback()
        }
      }
      var validateSocialCreditCode = (rule, value, callback) => {
        if (value && !(value.length === 15 || value.length === 18)) {
          return callback(new Error('长度在 15 或 18 个大小写字母或者数字'))
        } else {
          callback()
        }
      }
      return {
        companyName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          // { min: 15, max: 18, message: '长度在 15 到 18 个大小写字母或者数字', trigger: 'blur' }
          { validator: validateSocialCreditCode, trigger: 'blur' }
        ],
        provinceId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: validateProvinceId, trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    companyName: {
      type: String,
      default: ''
    }
  },
  watch: {
    'companyName': {
      handler: 'changeCompanyName',
      immediate: true
    }
  },
  mounted () {
    this.getProvinceList()
  },
  methods: {
    getProvinceList () {
      this.$http.post('/help/sys/sysProvince/queryList', {}).then(({ data: res }) => {
        this.provinceList = res.data
      }).catch(() => { })
    },
    changeCompanyName () {
      this.dataForm.companyName = this.companyName
    },
    // 选择省
    changeProvince () {
      this.dataForm.cityId = ''
      this.dataForm.areaId = ''
      this.cityList = []
      this.areaList = []
      this.$http.post('/help/sys/sysCity/queryList', { codeP: this.dataForm.provinceId })
        .then(({ data: res }) => {
          this.cityList = res.data
        }).catch(() => { })
    },
    // 选择市
    changeCity () {
      this.dataForm.areaId = ''
      this.areaList = []
      this.$http.post('/help/sys/sysArea/queryList', { codeC: this.dataForm.cityId })
        .then(({ data: res }) => {
          this.areaList = res.data
        }).catch(() => { })
    },
    // 校验图片格式
    beforeUpload (file) {
      let type = file.name.substring(file.name.lastIndexOf('.'))
      const isLt2M = file.size / 1024 / 1024 < 8
      var reg = /\.(jpg|bmp|gif|jpeg|png|pdf)$/
      const isJPG = reg.test(type)

      if (!isJPG) {
        this.$message.error('上传文件只能是 jpg|bmp|gif|jpeg|png 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 8MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
      return isJPG && isLt2M
    },
    // 上传营业执照成功
    handleSuccess (res) {
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.businessLicenseUrl = res.data.url
        this.businessLicenseId = res.data.aliOssId
      } else {
        this.$message({
          message: res.message,
          type: 'error'
        })
      }
    },
    fomatDataForm () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let fileList = []
        if (this.businessLicenseId) {
          fileList.push({
            fileId: this.businessLicenseId,
            type: 40
          })
        }
        this.dataForm.fileList = fileList
        this.$emit('submitHandle')
      })
    },
    deleteHandle (id, key) {
      if (key) {
        this[key + 'Id'] = ''
        this[key + 'Url'] = ''
      }
      if (id) {
        this.$http.post(`/help/fileupload/sys/deleteAliOss`, {
          'aliOssId': id
        })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.tab-main {
  width: 600px;
  padding: 20px 40px;
}
.tip {
  font-size: 14px;
  color: #999999;
}
.upLoad-but {
  width: 150px;
  height: 100px;
  position: relative;
  .delete{
    color: #fff;
    position: absolute;
    right: 50%;
    top: 50%;
    cursor: pointer;
  }
}
</style>
